// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/root/workspace/__flow_work/__flow_builds/5518bdd9-0b5e-4b19-8a03-ded86a1a2163/workspace/code/enderrealm-console/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: '@@initialState', model: model_1 },
} as const
